import { appConstants } from "constants/appConstants";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { venueService } from "services/venueService";
import { RootState } from "store";
import { setSettings } from "store/apps/settings";

const { REACT_APP_DEFAULT_VENUE_ID } = process.env;

export default function useHomeVenueDetail() {
  const [venue, setVenue] = useState<any>(null);

  const { language } = useSelector((state: RootState) => state.lang);

  const dispatch = useDispatch();

  useEffect(() => {
    (async function () {
      const results = await venueService.getVenueByVenueId(Number(REACT_APP_DEFAULT_VENUE_ID));

      if (!results) return;

      const result = results[0];

      const coord = result?.coordinates.split(",");

      const data = {
        venue_name: language === appConstants.LANGUAGE.DEFAULT_LANGUAGE ? result.venue_name_tc : result.venue_name_en,
        venue_desc: language === appConstants.LANGUAGE.DEFAULT_LANGUAGE ? result.venue_desc_tc : result.venue_desc_en,
        venue_content: language === appConstants.LANGUAGE.DEFAULT_LANGUAGE ? result.venue_content_tc : result.venue_content_en,
        venue_remarks: language === appConstants.LANGUAGE.DEFAULT_LANGUAGE ? result.venue_remarks_tc : result.venue_remarks_en,
        venue_location: language === appConstants.LANGUAGE.DEFAULT_LANGUAGE ? result.location_tc : result.location_en,
        map_url: coord.length > 1 ? `https://maps.google.com/maps?q=${coord[0]},${coord[1]}&t=&z=15&ie=UTF8&iwloc=&output=embed` : null,
      };

      dispatch(
        setSettings({
          allow_cancel_hour_before_start_time: result.allow_cancel_hour_before_start_time,
          auto_cancel_bookings_hours: result.auto_cancel_bookings_hours,
          is_enable_free_booking: result.is_enable_free_booking,
          max_booking_hours: result.max_booking_hours,
          min_booking_hours: result.min_booking_hours,
          remind_notification_hour: result.remind_notification_hour,
        })
      );

      setVenue({ ...result, ...data });
    })();
  }, [language]);

  return { venue };
}
